export default __webpack_public_path__ + "static/media/11.11.9d32bc35.jpg";